import { render, staticRenderFns } from "./doctor_congrats_2.vue?vue&type=template&id=0ea632a4&scoped=true&"
import script from "./doctor_congrats_2.vue?vue&type=script&lang=js&"
export * from "./doctor_congrats_2.vue?vue&type=script&lang=js&"
import style0 from "./doctor_congrats_2.vue?vue&type=style&index=0&id=0ea632a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea632a4",
  null
  
)

export default component.exports